import React from "react";
import Chart, { Props } from "react-apexcharts";

interface ChartProps {
	minX: number;
	data: { x: number; y: number }[];
	seriesName: string;
	loading: boolean;
	minY?: number;
	maxY?: number;
	decimals?: number;
	suffix?: string;
}

const CustomLineChart: React.FC<ChartProps> = ({
	data,
	seriesName,
	minX,
	loading,
	minY,
	maxY,
	decimals,
	suffix,
}) => {
	const formatValue = (value: number) => {
		const formatted =
			decimals !== undefined ? value.toFixed(decimals) : value.toString();
		return suffix ? `${formatted}${suffix}` : formatted;
	};
	const chartConfig: Props = {
		series: [
			{
				name: seriesName,
				data: data,
			},
		],
		options: {
			chart: {
				type: "area",
				height: 240,
				toolbar: {
					show: false,
				},
				stacked: false,
				zoom: {
					type: "x",
					enabled: true,
					autoScaleYaxis: true,
				},
			},
			title: {
				text: seriesName,
				align: "center",
			},
			dataLabels: {
				enabled: false,
			},
			colors: ["#020617"],
			stroke: {
				lineCap: "round" as const,
				curve: "smooth" as const,
			},
			markers: {
				size: 0,
			},
			xaxis: {
				labels: {
					style: {
						colors: "#616161",
						fontSize: "12px",
						fontFamily: "inherit",
						fontWeight: 400,
					},
				},
				type: "datetime",
				min: minX,
			},
			yaxis: {
				min: minY,
				max: maxY,
				labels: {
					style: {
						colors: "#616161",
						fontSize: "12px",
						fontFamily: "inherit",
						fontWeight: 400,
					},
					formatter: formatValue,
				},
			},
			grid: {
				show: true,
				borderColor: "#dddddd",
				strokeDashArray: 5,
				xaxis: {
					lines: {
						show: true,
					},
				},
				padding: {
					top: 5,
					right: 20,
				},
			},
			fill: {
				opacity: 0.8,
			},
			tooltip: {
				theme: "dark",
				y: {
					formatter: formatValue,
				},
			},
		},
	};

	return (
		<div style={{ position: "relative", height: 240 }}>
			<Chart
				options={chartConfig.options as any}
				series={chartConfig.series}
				type="line"
				height={240}
			/>
			{loading && (
				<div
					style={{
						position: "absolute",
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: "rgba(255, 255, 255, 0.8)",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						zIndex: 10,
					}}
				>
					<span style={{ fontSize: "16px", color: "#020617" }}>
						Carregando...
					</span>
				</div>
			)}
		</div>
	);
};

export default CustomLineChart;
